import React, { useEffect, useState } from "react";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import useStore from "../../../Store";
import { useParams } from "react-router-dom";
import { getResourceById } from "../../../Services/APIrequests";
import { GoArrowRight } from "react-icons/go";
import ReactPlayer from "react-player";
import styles from "./SingleResource.module.css";
import parse from "html-react-parser";
import defaultIMG from "../../../Assets/defaultimg.png";
import { RotatingLines } from "react-loader-spinner";
import Resource1 from './Resource1'

const SingleResource = () => {
  const { resourceId } = useParams();
  const [resource, setResource] = useState(null);
  const direction = useStore((state) => state.direction);

  useEffect(() => {
    const fetchResource = async () => {
      try {
        const response = await getResourceById(resourceId);
        setResource(response.data);
      } catch (error) {
        console.error("Error fetching resource:", error);
      }
    };
    fetchResource();
  }, [resourceId]);

  if (!resource) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <RotatingLines height="80" width="80" color="#4fa94d" visible={true} />
      </div>
    );
  }

  return (
    <div style={{ direction }}>
      <Nav />
                <Resource1 />
      <div className={styles.Single_resources_container}>
        <div className={styles.ReadmoreContainer}>
          <div className={styles.Readmoreheader}>
            <h1>{resource.title}</h1>

            {/* Display media */}
            {resource.videoURL && resource.videoURL !== "NA" ? (
              <div className={styles.ReadmoreheaderVideo}>
                <ReactPlayer url={resource.videoURL} controls width="100%" height="100%" />
              </div>
            ) : resource.image && resource.image !== "NA" ? (
              <div className={styles.ReadmoreheaderImage}>
                <img
                  src={resource.image}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = defaultIMG;
                  }}
                  alt={resource.title}
                />
              </div>
            ) : null}

            <p>{parse(resource.shortDescription)}</p>
          </div>

          <p className={styles.readmorelongDescription}>
            {parse(resource.longDescription)}
          </p>

          <div className={styles.resourcesbutton_container}>
            <button
              type="button"
              className={styles.r_btn}
              onClick={() => {
                if (resource.fileURL) window.open(resource.fileURL, "_blank");
                else alert("No form available for this resource.");
              }}
            >
              View Form <GoArrowRight size={22} />
            </button>

            {resource.fileURL ? (
              <a href={resource.fileURL} download className={styles.r2_btn}>
                Download Form <GoArrowRight size={22} />
              </a>
            ) : (
              <button
                type="button"
                className={styles.r2_btn}
                onClick={() => alert("No form available to download.")}
              >
                Download Form <GoArrowRight size={22} />
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SingleResource;
